export default __webpack_public_path__ + "static/media/btn_google_light_normal_ios.0e8ec131.svg";